import type { TFunction } from "i18next";
import { useTranslation } from "react-i18next";
import { normalizeHalalStatus } from "../../../utils/halalStatus";
import styles from "./HalalStatusBadge.module.css";

const STATUS_CLASS: Record<string, string> = {
  halal: styles.halal,
  doubtful: styles.doubtful,
  not_halal: styles.notHalal,
  unqualified: styles.unqualified,
};

function statusLabel(status: string, t: TFunction): string {
  const normalized = normalizeHalalStatus(status);
  if (normalized === "halal") return t("pages.stockScreener.status.halal");
  if (normalized === "doubtful") return t("pages.stockScreener.status.doubtful");
  if (normalized === "not_halal") return t("pages.stockScreener.status.notHalal");
  if (normalized === "unqualified") return t("pages.stockScreener.status.notQualified");
  if (!status || status === "-") return "-";
  return status
    .replace(/[_-]/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

type HalalStatusBadgeProps = {
  status?: string | null;
  className?: string;
};

export function HalalStatusBadge({ status, className }: HalalStatusBadgeProps) {
  const { t } = useTranslation();
  if (!status || status === "-") {
    return <span className={styles.empty}>-</span>;
  }

  const normalized = normalizeHalalStatus(status);
  const toneClass = STATUS_CLASS[normalized] ?? styles.unknown;

  return (
    <span className={[styles.badge, toneClass, className].filter(Boolean).join(" ")}>
      {statusLabel(status, t)}
    </span>
  );
}
